import * as UI from "@iyk/ui"
import { Data } from "effect"

const make = Data.case<Config>()

export const config = make({
  appId: "yoo-youngjae",
  general: {
    email: "yooyoungjae@iyk.app",
    name: "Yoo Young Jae (유영재)",
    baseUrl: "https://yooyoungjae.iyk.app",
  },
  meta: {
    description: "Yoo Young Jae (유영재)",
  },
  social: [
    {
      label: "Instagram",
      logo: UI.Icon.Instagram,
      href: "https://www.instagram.com/yjaybaby",
    },
    {
      label: "X",
      logo: UI.Icon.X,
      href: "https://x.com/BAP_Youngjae",
    },
    {
      label: "YouTube",
      logo: UI.Icon.Youtube,
      href: "https://www.youtube.com/channel/UC0O6aYQjPZf0HRs9pwE9W3w/feed?app=desktop",
    },
    {
      label: "Instagram",
      logo: UI.Icon.Instagram,
      href: "https://www.instagram.com/oneione_kr/",
    },
  ],
})

interface Config {
  appId: string
  general: {
    email: string
    name: string
    baseUrl: string
  }
  meta: {
    description: string
  }
  social: Array<{
    label: string
    logo: React.ElementType
    href: string
  }>
}
